// @flow @format
import * as fs from 'lib/fs';

class BlocksWriter {
	_filename: string;
	_dirEntry: FileSystemDirectoryEntry;

	constructor(dirEntry: FileSystemDirectoryEntry, filename: string) {
		this._filename = filename;
		this._dirEntry = dirEntry;
	}

	getFile(): Promise<FileSystemFileEntry> {
		return fs.getFileEntry(this._dirEntry, this._filename);
	}

	deleteFile(): Promise<void> {
		return fs.deleteFileEntry(this._dirEntry, this._filename);
	}

	createFile(size: number): Promise<number> {
		return new Promise((resolve, reject) =>
			fs
				.createFileEntry(this._dirEntry, this._filename)
				.then(fileEntry => fs.getFileWriter(fileEntry))
				.then(fileWriter => {
					fileWriter.onwriteend = () => resolve(size);
					fileWriter.onerror = (error: FileError) => reject(error);
					fileWriter.truncate(size);
				})
				.catch(error => reject(error)),
		);
	}

	writeBlock(offset: number, blob: Blob): Promise<number> {
		return new Promise((resolve, reject) =>
			fs
				.getFileEntry(this._dirEntry, this._filename)
				.then(fileEntry => fs.getFileWriter(fileEntry))
				.then(fileWriter => {
					fileWriter.onwriteend = () => resolve(blob.size);
					fileWriter.onerror = (error: FileError) => reject(error);

					fileWriter.seek(offset);
					fileWriter.write(blob);
				})
				.catch(error => reject(error)),
		);
	}
}

export default BlocksWriter;



// WEBPACK FOOTER //
// ./src/lib/downloader/writer.js